<div *ngIf="event" class="col-md-12 event-content" data-test="event-header">
  <div class="row">
    <div class="image col-lg-2" data-test="result-header-image">
      <img
        *ngIf="event?.assetUrl"
        [lazyLoad]="event?.assetUrl | floImage: 160:0 | async"
      />
    </div>

    <div class="event-info col-md-12 col-lg-5">
      <div class="title">
        <i *ngIf="event?.showLiveBadge" floSvg="badge_live"></i>
        <span>{{ event?.title }}</span>
      </div>

      <div class="subheader" data-test="subheader-date"
        >{{ event?.start_date_time | floDate: event?.end_date_time }}
        <span>{{ event?.statusText }}</span
        ><span *ngIf="event?.statusStartTime">{{
          event?.statusStartTime
        }}</span>
      </div>
      <a [routerLink]="event?.eventLink ? event.eventLink : []" *ngIf="event?.liveEventButton">
        <button
          (click)="onButtonClick()"
          class="{{ event.btnClass }} mobile-watch-live"
          >{{ event?.buttonText }}
        </button>
      </a>
    </div>

    <div class="col-lg-1"></div>
    <div
      class="event-social col-md-12 col-lg-4"
      floFetchGeo
      data-test="watch-button"
    >
      <a [routerLink]="event?.eventLink ? event.eventLink : []" *ngIf="event?.liveEventButton">
        <button (click)="onButtonClick()" class="{{ event.btnClass }}">{{
          event?.buttonText
        }}</button>
      </a>
      <flo-live-geo-ip
        *floFetchFillItem="
          let response of event.live_id;
          usingOutputKey: event.live_id
        "
        [title]="response.message"
      ></flo-live-geo-ip>
    </div>
  </div>
</div>
